import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "bp-progress-indicator",
	templateUrl: "./bp-progress-indicator.component.html",
	styleUrls: ["./bp-progress-indicator.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpProgressIndicatorComponent {
	@Input()
	value: number;
}
